import styled from "styled-components";
import Colors from "../../constants/Colors";

export const ContainerHeaderPainel = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const FlexEndHeaderPainel = styled.div``;

export const ContainerListPainel = styled.div`
padding: 10px;
  height: 55vh;
  overflow-y: scroll;

  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #e0f0f5;
    border-radius: 8px;
  }

  ::-webkit-scrollbar-thumb {
    background: #556ed1;
    border-radius: 5px;
  }
`;


export const CalendarRowContainer = styled.div<{ isMobile?: boolean }>`
  width: ${(props) => (props.isMobile ? "90%" : "98%")};
  height: ${(props) => (props.isMobile ? "60px" : "55px")};
  flex-direction: ${(props) => (props.isMobile ? "column" : "row")};
  display: flex;
  justify-content: space-between;
}
`;

export const CalendarAnchor = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-direction: row;
  cursor: pointer;
  margin-left: 10px;
  text-align: center;
  padding: 10px 14px;
  align-items: center;
  justify-content: space-between;
  width: ${(props) => (props.isMobile ? "100%" : "283px")};
  border-radius: 8px;
  background-color: ${Colors.SPM50};
  border: 1px solid ${Colors.SPM100};
`;